import Vue from 'vue'
import Print from 'vue-print-nb'
// Global instruction
Vue.use(Print)
